import { ClassRoom } from './ClassRoom';
export default ClassRoom;